// filePath：statistics.js #startLine: 1 #endLine: 55
import request from "@/utils/request";

export default {
    // 每日采购汇总
    getDailyPurchaseSummary(date) {
        return request.get('/api/statistics/daily_purchase', {
            params: { date }
        });
    },

    // 月度客户汇总
    getMonthlyCustomerSummary(year, month) {
        return request.get('/api/statistics/monthly_customer', {
            params: { year, month }
        });
    },

};